module.exports = __webpack_public_path__ + "82779f8ee1e9aeac33eccf5a1e790aab.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/head/bow-hair-pink.png
// module id = 2649
// module chunks = 0